import { Postman } from "../Postman";
import { ApiResource } from "../ApiResource";
import { ApiSearchResult } from "./ApiSearchResult";
export class ApiSearchResource extends ApiResource {
    constructor(client, route, searchType, version = "1.0") {
        super(client, route, version);
        this._searchType = searchType;
    }
    search(searchText, page = 0, size = 20) {
        return new Promise((resolve, reject) => {
            this._apiCall(ApiSearchResult, Postman.GET, {
                url: ApiSearchResource.SEARCH_ROUTE,
                params: {
                    searchable: searchText,
                    type: this._searchType,
                    page,
                    size,
                },
            })
                .then((res) => {
                resolve(res);
                // if (!!res) {
                //     resolve(res);
                // } else {
                //     resolve(ApiSearchResult.EMPTY);
                // }
            })
                .catch((err) => {
                reject(err);
            });
        });
    }
}
// All models are searchable via this generic route,
// be it a presentation, fodler or other models.
ApiSearchResource.SEARCH_ROUTE = "/conference/feature/search";
